import { render, staticRenderFns } from "./biyeCount.vue?vue&type=template&id=242a297a&scoped=true"
import script from "./biyeCount.vue?vue&type=script&lang=js"
export * from "./biyeCount.vue?vue&type=script&lang=js"
import style0 from "./biyeCount.vue?vue&type=style&index=0&id=242a297a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a297a",
  null
  
)

export default component.exports